import React from "react";
import styled from "styled-components";

const BoxStyle = styled.div`
    width: 100%;
    margin: 0 auto;
    position: relative;
    margin-top: -460px;
    color: ${props => props.theme.black};
    max-width: ${props => props.$maxWidth};
    box-shadow: ${props => props.theme.boxShadow};
    background-color: ${props => props.theme.white};
    >div {
        padding: 40px;
        display: block;
        margin-bottom: 40px;
    }
`;

export const Box = ({ maxWidth, children }) =>
    <BoxStyle $maxWidth={maxWidth}>
        <div>
            {children}
        </div>
    </BoxStyle>;